import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MobileMenuContainer from "../Dashboard/mobilemenu.jsx";
import "../Dashboard/styles.css";


export default function SideNav() {
  const [isMobileMenuVisible] = useState(false);
  const [usersDropdownOpen, setUsersDropdownOpen] = useState(false);
  const [packagesDropdownOpen, setPackagesDropdownOpen] = useState(false);

  const navigate = useNavigate();

  const handleLogout = () => {
    console.log("Logging out...");
    // Clear admin data from local storage (assuming you stored it with key 'adminData')
    localStorage.removeItem('loggedInUser');

    // Navigate to the home page
    navigate('/');
  };

  const toggleUsersDropdown = () => {
    setUsersDropdownOpen(!usersDropdownOpen);
  };

  const togglePackagesDropdown = () => {
    setPackagesDropdownOpen(!packagesDropdownOpen);
  };

  return (
    <>
      <MobileMenuContainer />
      <div
        className={`dashboard-navigation ${
          isMobileMenuVisible ? "hide-desktop-menu" : ""
        }`}
      >
        {/* Navigation */}
        <div id="navigation" className="navigation-container">
          <ul>
            <li>
              <Link activeClassName="active-menu" to="/Dashboard" className="nav-link">
                <i className="far fa-chart-bar" style={{ fontSize: "14px" }} />
                Dashboard
              </Link>
            </li>
            <li>
              <div
                className="dropdown-item-side-nav"
                onClick={toggleUsersDropdown}
              >
                <div className="dropdown-item-header">
                  <i className="fas fa-user" style={{ fontSize: "14px" }} />
                  Users
                  <span style={{ marginLeft: "auto" }}>
                    {usersDropdownOpen ? (
                      <i
                        className="fas fa-minus"
                        style={{ marginRight: "8px" }}
                      />
                    ) : (
                      <i
                        className="fas fa-plus"
                        style={{ marginRight: "8px" }}
                      />
                    )}
                  </span>
                </div>
                {/*  here sub menu class and here its style also not used */}
                {usersDropdownOpen && (
                  <ul
                    className="sub-menu"
                    style={{ listStyleType: "none", padding: 0 }}
                  >
                    <li>
                      <Link
                        activeClassName="active-menu"
                        to="/Dashboard/users"
                        className="nav-link"
                      >
                        User List
                      </Link>
                    </li>
                    <li>
                      <Link
                        activeClassName="active-menu"
                        to="/Dashboard/users/edit"
                        className="nav-link"
                      >
                        Admin List
                      </Link>
                    </li>
                    <li>
                      <Link
                        activeClassName="active-menu"
                        to="/Dashboard/users/new"
                        className="nav-link"
                      >
                        Admin Registeration
                      </Link>
                    </li>
                  </ul>
                )}
              </div>
            </li>
            <li>
              {/* here not used class=>dropdown-item-side-nav used class => dropdown-item-sidenav */}
              <div
                className="dropdown-item-side-nav"
                onClick={togglePackagesDropdown}
              >
                <div className="dropdown-item-header">
                  <i className="fas fa-hotel" style={{ fontSize: "14px" }} />
                  Packages
                  <span style={{ marginLeft: "auto" }}>
                    {packagesDropdownOpen ? (
                      <i
                        className="fas fa-minus"
                        style={{ marginRight: "8px" }}
                      />
                    ) : (
                      <i
                        className="fas fa-plus"
                        style={{ marginRight: "8px" }}
                      />
                    )}
                  </span>
                </div>
                {packagesDropdownOpen && (
                  <ul
                    className="sub-menu"
                    style={{ listStyleType: "none", padding: 0 }}
                  >
                    <li>
                    <Link
                      activeClassName="active-menu"
                      to="/Dashboard/package"
                      className="nav-link"
                    >
                      Add Package
                    </Link>
                    </li>
                    <li>
                      <Link
                        activeClassName="active-menu"
                        to="/Dashboard/package/active"
                        className="nav-link"
                      >
                        Active Packages
                      </Link>
                    </li>
                  </ul>
                )}
              </div>
            </li>
            <li>
              <button activeClassName="active-menu" className="nav-link" onClick={handleLogout}>
                <i className="fas fa-sign-out-alt" style={{ fontSize: "16px", padding: "15px"}} /> Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}
